export const convertArrayBufferToFile = ({
  arrayBuffer,
  fileName,
  mimeType,
  lastModified,
}: {
  arrayBuffer: ArrayBuffer;
  fileName: string;
  mimeType: string;
  lastModified?: number;
}) => {
  return new File([arrayBuffer], fileName, { type: mimeType, lastModified });
};

export const transformGoogleImageUrl = (originalUrl: string, targetHost = 'http://localhost', port = 80) => {
  // Verifica se l'URL è nel formato corretto
  if (!originalUrl || typeof originalUrl !== 'string') {
    return '';
  }

  // Verifica se l'URL inizia con https://lh3.googleusercontent.com/
  const prefix = 'https://lh3.googleusercontent.com/';
  if (!originalUrl.startsWith(prefix)) {
    return '';
  }

  // Estrai il percorso dopo lh3.googleusercontent.com/
  const path = originalUrl.substring(prefix.length);

  // Costruisci il nuovo URL, includendo la porta solo se non è 80
  const portPart = port === 80 ? '' : `:${port}`;
  return `${targetHost}${portPart}/google-images/${path}`;
};
